.tooltipMeasure {
	visibility: hidden;
	position: fixed;
	white-space: pre-wrap;
	word-break: break-all;
	width: 500px;
	font-size: 0.8125rem;
	font-weight: 500;
	line-height: 1.6;
	pointer-events: none;
	max-height: 47px;
	overflow: hidden;
}

.tooltipScrollContent {
	height: 44px;
	overflow-y: auto;
	padding-right: 4px;
	word-break: break-word;
}

.customTooltip {
	max-height: 60px;
}

.customTooltipLong {
	max-height: 60px;
	overflow: visible;
	white-space: pre-wrap;
	word-break: break-all;
}

.ellipsis {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

@media (max-width: 784px) {
	.tooltipMeasure {
		width: unset;
		max-width: 100%;
	}
}
